<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'md'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="container">
      <CRow>
        <CCol lg="6" md="6" sm="6">
          <p>Nombre: {{ data.name }}</p>
        </CCol>
        <CCol lg="6" md="6" sm="6">
          <p>Documento: {{ data.document }}</p>
        </CCol>
        <CCol lg="6" md="6" sm="6">
          <CInput label="Celular" placeholder="celular" v-model="client.phone" maxlength="9"></CInput>
        </CCol>
        <CCol lg="6" md="6" sm="6">
          <CInput label="Correo" placeholder="correo" v-model="client.email"></CInput>
        </CCol>
        <CCol lg="12" md="12" sm="12">
          <CInput label="Distrito" placeholder="distrito" v-model="client.district"></CInput>
        </CCol>
        <CCol lg="6" md="6" sm="6">
          <CSelect label="Mes" :value.sync="client.month" 
          :options="months" placeholder="--Seleccione un mes--"/>
        </CCol>
        <CCol lg="6" md="6" sm="6">
          <CInput label="Día" type="number" v-model="client.day" min="1" max="31" placeholder="Día"></CInput>
        </CCol>
        <!-- <CCol lg="6" md="6" sm="6">
          <CInput label="Fecha de Nac" type="date" v-model="client.fech_nacimiento"></CInput>
        </CCol> -->
      </CRow>
    </div>
    <template #footer>
      <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
      <CButton class="btn-info" @click="mtdSaveClient">
        <i class="fa fa-save"></i>&nbsp;Guardar
      </CButton>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";

export default {
  name: "c-dataclient-modal",
  components: {
    CModal,
  },
  data() {
    return {
      months: [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ],
      swal: null,
      client: {
        id: "",
        day: "",
        month: null,
        phone: "",
        email: "",
        district: "",
      },
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    data: {
      type: Object,
      default: () => ({}),
    }
  },
  watch: {
    data: {
      // immediate: true,
      handler(newData) {
        const company = this.$store.getters.get_company.id;
        const client_id = newData.Id;
        const state = newData.status == "Activo" ? 1 : "";
        this.client = { ...newData,  company_id: company, id: client_id, state: state };
        if (newData?.fech_nacimiento) {
          const [month, day] = newData.fech_nacimiento.split("-");
          this.client.day = day;
          this.client.month = this.months[parseInt(month, 10) - 1];;
        }
      },
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.$emit("closeModalDataClient");
    },
    formatDateToYYYYMMDD(dateString) {
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    },
    mtdSaveClient: function () {
      const url = this.$store.getters.get__url + (this.client.id ? "/client/update" : "/client/store");
      this.post({
        url: url,
        token: this.$store.getters.get__token,
        params: this.client,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            Swal.fire({
              title: "Cliente Registrado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.mtdClose();
          }
        })
        .catch((errors) => { });

    },
  },
};
</script>

<style scoped>
.bg-purple {
  background-color: #00003a;
}

.color-white {
  color: white;
}

.tamanio {
  max-height: 180px;
  overflow-y: auto;
}
</style>